import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { RouteComponentProps } from 'react-router';
import { Dispatch, connect } from 'react-redux';
import { AxiosError } from 'axios';
import { IBaseResponse, IConnectToDonorStatus, IDonorConnect, IDonorConnectCounts, IListItem } from '@nkr/models/index';
import {
    IApplicationState, AppActionCreators, IAppState, IIldaListResponse, IIldaLogListResponse,
    DashActionCreators, IIldaLookupDataResponse, IIldaLogResponse, IIldaRegistrationResponse, IIldaCountResponse
} from '@nkr/store/index';
import { Badge, Glyphicon, NavItem, OverlayTrigger } from 'react-bootstrap';
import { Wrapper, NavWrapper } from './styles';
import Loader from 'react-spinners/ClockLoader';
import { toast } from 'react-toastify';
import Drawer from 'rc-drawer';
import ViewRegistration from './view-registration';
import MobileView from './mobile-view';
import { donorConnectTabs, ICounselor, ICounts, tabMap } from './models';
import MediaQuery from 'react-responsive';
import informationOverlay from './information';
import Filters from '../donor-connect/filters';
import IldaGrid from './grid';

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IProps extends RouteComponentProps<{}> { }

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getIldaList: (listType: number, counselorFilter: number, statusFilter: number, showFilter: number, searchFilter: string) => Promise<IIldaListResponse>,
    getIldaCounts: () => Promise<IIldaCountResponse>,
    getLookupData: () => Promise<IIldaLookupDataResponse>,
    getIldaLogEntries: (id: number) => Promise<IIldaLogListResponse>,
    getIldaRegistration: (id: number) => Promise<IIldaRegistrationResponse>,
    changeStatus: (id: number, status: number) => Promise<IBaseResponse>,
    changeAssignedCounselor: (id: number, userId: number) => Promise<IBaseResponse>,
    unassignCounselor: (id: number) => Promise<IBaseResponse>,
    updateNextFollowUpDate: (id: number, date: string) => Promise<IBaseResponse>,
    saveLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string) => Promise<IIldaLogResponse>,
    deleteLogEntry: (id: number) => Promise<IBaseResponse>

}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: IDonorConnect[],
    counts: IDonorConnectCounts,
    statusList: IConnectToDonorStatus[],
    actionList: IListItem[],
    userList: ICounselor[],
    fetching: boolean,
    currentTab: string,
    userFilter: number,
    statusFilter: number,
    showFilter: number,
    searchFilter: string,
    view: {
        show: boolean,
        data: IDonorConnect
    }
}

class IldaApp extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        counts: null,
        statusList: [],
        actionList: [],
        userList: [],
        fetching: false,
        currentTab: donorConnectTabs.TODO,
        userFilter: -1,
        statusFilter: -1,
        showFilter: 0,
        searchFilter: '',
        view: {
            show: false,
            data: null
        }
    }

    container: HTMLDivElement;
    intervalId: any;

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    componentDidMount = () => {
        this.getData(true);
    }

    handleTabChange = (currentTab: string) => {
        this.setState({
            currentTab
        }, () => {
            this.refreshData();
        });
    }

    handleFilterChange = (property: string, value: any) => {
        if (property == 'statusFilter') {
            this.setState({
                statusFilter: parseInt(value)
            });
        }

        if (property == 'userFilter') {
            this.setState({
                userFilter: parseInt(value)
            });
        }

        if (property == 'showFilter') {
            this.setState({
                showFilter: parseInt(value)
            });
        }

        if (property == 'searchFilter') {
            this.setState({
                searchFilter: value
            });
        }
    }

    handleSubmitFilters = (reset: boolean) => {
        if (reset) {
            this.setState({
                userFilter: -1,
                statusFilter: -1,
                showFilter: 0,
                searchFilter: ''
            }, () => {
                this.refreshData();
            });
        } else {
            this.refreshData();
        }
    }

    handleStatusChange = (id: number, statusId: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.props.showLoading('Changing status, one moment please...').then(() => {
            this.props.changeStatus(id, statusId).then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    var logResponse = await this.props.getIldaLogEntries(id);

                    let status = this.state.statusList.find(x => x.id == statusId);

                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == id) {
                            item.connectToDonorStatusId = statusId;
                            item.connectToDonorStatus = status.description;
                            item.logs = logResponse.data.results;
                        }

                        return item;
                    });

                    if (this.state.view.show) {
                        data = list.find(x => x.id == this.state.view.data.id);
                    }

                    this.setState({
                        list,
                        view: { ...this.state.view, data }
                    }, () => {
                        toast.success('Status changed successfully');
                    });
                }
            });
        });
    }

    handleAssignedCounselorChange = (id: number, userId: number) => {
        let data = this.state.list.find(x => x.id == id);

        if (userId > 0) {
            this.props.showLoading('Changing assigned mentor, one moment please...').then(() => {
                this.props.changeAssignedCounselor(id, userId).then(async response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        if (this.state.currentTab == donorConnectTabs.ALL) {
                            let countResponse = await this.props.getIldaCounts();
                            let logResponse = await this.props.getIldaLogEntries(id);

                            let user = this.state.userList.find(x => id == userId);

                            let list = _.cloneDeep(this.state.list).map(item => {
                                if (item.id == id) {
                                    item.connectToDonorAssignedUserId = userId;
                                    item.connectToDonorAssigndUser = user;
                                    item.logs = logResponse.data.results;
                                }

                                return item;
                            });

                            if (this.state.view.show) {
                                data = list.find(x => x.id == this.state.view.data.id);
                            }

                            this.setState({
                                list,
                                counts: countResponse.data.results,
                                view: { ...this.state.view, data }
                            }, () => {
                                toast.success('Assigned mentor changed successfully');
                            });
                        } else {
                            this.refreshData().then(() => {
                                this.setState({
                                    view: {
                                        show: false,
                                        data: null
                                    }
                                }, () => {
                                    toast.success('Assigned mentor changed successfully');
                                });
                            });
                        }
                    }
                });
            });
        } else {
            this.props.showLoading('Unassigning counselor, one moment please...').then(() => {
                this.props.unassignCounselor(id).then(async response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        if (this.state.currentTab == donorConnectTabs.ALL) {
                            let countResponse = await this.props.getIldaCounts();
                            let logResponse = await this.props.getIldaLogEntries(id);

                            let list = _.cloneDeep(this.state.list).map(item => {
                                if (item.id == id) {
                                    item.connectToDonorAssignedUserId = 0;
                                    item.connectToDonorAssigndUser = null;
                                    item.logs = logResponse.data.results;
                                }

                                return item;
                            });

                            if (this.state.view.show) {
                                data = list.find(x => x.id == this.state.view.data.id);
                            }

                            this.setState({
                                list,
                                counts: countResponse.data.results,
                                view: { ...this.state.view, data }
                            }, () => {
                                toast.success('Counselor unassigned successfully');
                            });
                        } else {
                            this.refreshData().then(() => {
                                this.setState({
                                    view: {
                                        show: false,
                                        data: null
                                    }
                                }, () => {
                                    toast.success('Counselor unassigned successfully');
                                });
                            });
                        }
                    }
                });
            });
        }
    }

    handleNextFollowUpDateChange = (date: string) => {
        let data = _.cloneDeep(this.state.view.data);
        data.connectToDonorNextFollowUpDate = date;

        this.setState({
            view: {
                ...this.state.view,
                data
            }
        });
    }

    handleNextFollowUpDateChangeMobile = (id: number, date: string) => {
        let list = _.cloneDeep(this.state.list).map(x => {
            if (x.id == id) {
                x.connectToDonorNextFollowUpDate = date;
            }

            return x;
        });

        this.setState({
            list
        });
    }

    handleUpdateNextFollowupDateMobile = (id: number) => {
        let item = this.state.list.find(x => x.id == id);
        let date = item != null ? item.connectToDonorNextFollowUpDate : '';

        this.updateNextFollowUpDate(id, date);
    }

    handleUpdateNextFollowUpDate = (id: number) => {
        let { connectToDonorNextFollowUpDate } = this.state.view.data;
        this.updateNextFollowUpDate(id, connectToDonorNextFollowUpDate);
    }

    handleRemoveNextFollowUpDate = (id: number) => {
        let data = _.cloneDeep(this.state.view.data);
        data.connectToDonorNextFollowUpDate = '';

        this.setState({
            view: {
                ...this.state.view,
                data
            }
        }, () => {
            this.removeNextFollowUpDate(id);
        });
    }

    handleViewRegistration = async (id: number) => {
        this.getLogData(id, true);
    }

    handleCancelView = () => {
        this.setState({
            view: {
                show: false,
                data: null
            }
        });
    }

    handleSaveLogEntry = (id: number, dashRegistrationId: number, actionTaken: number, comments: string) => {
        let message = id == 0 ? 'Adding log entry, one moment please...' : 'Updating log entry, one moment please...';

        this.props.showLoading(message).then(() => {
            this.props.saveLogEntry(id, dashRegistrationId, actionTaken, comments)
                .then(response => {
                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == dashRegistrationId) {
                            if (id == 0) {
                                item.logs.push(response.data.results);
                            } else {
                                item.logs = item.logs.map(logItem => {
                                    if (logItem.id == id) {
                                        return response.data.results;
                                    }
                                    return logItem;
                                })
                            }
                        }

                        return item;
                    });

                    let data = list.find(x => x.id == dashRegistrationId);

                    this.setState({
                        list,
                        view: { show: true, data }
                    }, () => {
                        this.props.hideLoading();
                        toast.success(id == 0 ? 'Log entry added successfully' : 'Log entry updated successfully');
                    });
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleDeleteLogEntry = (id: number, dashRegistrationId: number) => {
        this.props.showLoading('Deleting log entry, one moment please...').then(() => {
            this.props.deleteLogEntry(id)
                .then(response => {
                    if (response.data.success) {
                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == dashRegistrationId) {
                                item.logs = item.logs.filter(logItem => logItem.id != id);
                            }

                            return item;
                        });

                        let data = list.find(x => x.id == dashRegistrationId);

                        this.setState({
                            list,
                            view: { show: true, data }
                        }, () => {
                            this.props.hideLoading();
                            toast.success('Log entry delete successfully');
                        });
                    }
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    updateNextFollowUpDate = (id: number, date: string) => {
        this.props.showLoading('Changing next follow-up date, one moment please...').then(() => {
            this.props.updateNextFollowUpDate(id, date).then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    var logResponse = await this.props.getIldaLogEntries(id);

                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == id) {
                            item.connectToDonorNextFollowUpDate = date;
                            item.logs = logResponse.data.results;
                        }

                        return item;
                    });

                    this.setState({
                        list,
                    }, () => {
                        toast.success('Next follow-up date changed successfully');
                    });
                }
            });
        });
    }

    removeNextFollowUpDate = (id: number) => {
        this.props.showLoading('Removing next follow-up date, one moment please...').then(() => {
            this.props.updateNextFollowUpDate(id, '').then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    var logResponse = await this.props.getIldaLogEntries(id);

                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == id) {
                            item.connectToDonorNextFollowUpDate = moment().add(2, 'day').format('MM/DD/YYYY');
                            item.logs = logResponse.data.results;
                        }

                        return item;
                    });

                    this.setState({
                        list
                    }, () => {
                        toast.success('Next follow-up date removed successfully');
                    });
                }
            });
        });
    }

    getData = (message: boolean) => {
        let path = this.props.match.path;
        let t = tabMap.find(x => x.url == path);
        let currentTab = t != null ? t.name : donorConnectTabs.TODO;
        let { userFilter: counselorFilter, statusFilter, showFilter, searchFilter } = this.state;

        if (t == null) {
            t = tabMap.find(x => x.name == currentTab);
        }

        let start = message ? this.props.showLoading('Getting ILDA registrations, one moment please...') : Promise.resolve(null);

        start.then(() => {
            this.setState({
                fetching: message == true ? false : true,
                currentTab
            }, () => {
                Promise
                    .all([
                        this.props.getIldaList(t.id, counselorFilter, statusFilter, showFilter, searchFilter),
                        this.props.getLookupData()
                    ])
                    .then(([listResponse, lookupDataResponse]) => {
                        if (listResponse.data.success && lookupDataResponse.data.success) {
                            let { list, counts } = listResponse.data.results;
                            let { statusList, actionList, userList } = lookupDataResponse.data.results;

                            this.setState({
                                list,
                                counts,
                                statusList,
                                actionList,
                                userList: userList.map(x => {
                                    let thisUserCases = list.filter(r => r.connectToDonorAssignedUserId == x.id);
                                    let newRequestCount = thisUserCases.filter(r => r.connectToDonorStatusId == 0).length;
                                    let withinTwoWeeksCount = thisUserCases.filter(r => r.connectToDonorNextFollowUpDate != '' ? moment(r.connectToDonorNextFollowUpDate, 'MM/DD/YYYY', true).isSameOrAfter(moment()) && moment(r.connectToDonorNextFollowUpDate, 'MM/DD/YYYY', true).isBefore(moment().add(14, 'day'), 'day') : false).length;
                                    let activeCaseCount = newRequestCount + withinTwoWeeksCount;

                                    return {
                                        ...x,
                                        activeCaseCount
                                    }
                                }),
                                fetching: false
                            });
                        }

                        this.props.hideLoading();
                    });
            });
        });
    }

    refreshData = () => {
        let t = tabMap.find(x => x.name == this.state.currentTab);
        let { userFilter: counselorFilter, statusFilter, showFilter, searchFilter } = this.state;

        return this.props.showLoading('Getting registrations, one moment please...').then(() => {
            return this.props.getIldaList(t.id, counselorFilter, statusFilter, showFilter, searchFilter).then(response => {
                if (response.data.success) {
                    let { list, counts } = response.data.results;

                    this.setState({
                        list,
                        counts
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    getCounts = (): ICounts => {
        let unassigned = this.state.counts != null ? this.state.counts.unassignedCount : 0;
        let todo = this.state.counts != null ? this.state.counts.toDoCount : 0;
        let assignedToMe = this.state.counts != null ? this.state.counts.assignedToMeCount : 0;
        let all = this.state.counts != null ? this.state.counts.allCount : 0;

        return {
            unassigned,
            todo,
            assignedToMe,
            all
        };
    }

    getUserList = () => {
        let list = this.state.userList.map(user => {
            let thisUserCases = this.state.list.filter(x => {
                let status = this.state.statusList.find(s => s.id == x.connectToDonorStatusId);
                return x.connectToDonorAssignedUserId == user.id && status.isClosed == false;
            });

            let newRequestCount = thisUserCases.filter(x => {
                return x.connectToDonorStatusId == 0
            }).length;

            let withinTwoWeeksCount = thisUserCases.filter(x => {
                let cutoff = moment().add(14, 'day').hour(23).minute(59).second(59);

                return x.connectToDonorNextFollowUpDate != '' ?
                    moment(x.connectToDonorNextFollowUpDate, 'MM/DD/YYYY', true).isBefore(cutoff, 'day')
                    :
                    false
            }).length;

            user.activeCaseCount = newRequestCount + withinTwoWeeksCount;

            return user;
        });

        return list;
    }

    getLogData = async (id: number, view: boolean) => {
        let list = _.cloneDeep(this.state.list);
        let logResponse = await this.props.getIldaLogEntries(id);

        if (logResponse.data.success) {
            list = list.map(x => {
                if (x.id == id) {
                    x.logs = logResponse.data.results;
                }

                return x;
            });

            let data = _.cloneDeep(list.find(x => x.id == id));

            if (view) {
                this.setState({
                    list,
                    view: {
                        show: true,
                        data
                    }
                });
            } else {
                this.setState({
                    list
                });
            }
        }
    }

    render = () => {
        const list = this.state.list;
        const counts = this.getCounts();
        const userList = _.sortBy(this.state.userList, item => item.lastName);
        const isRestrictedToAssigned = this.props.app.user.roles.find(x => x.id == 210) != null;

        return (
            <>
                <MediaQuery minWidth={1024}>
                    <div ref={this.saveContainer} />
                    <div className='container-fluid'>
                        <div className='row' style={{ marginTop: 0, marginBottom: 30 }}>
                            <div className='col-xs-12 col-lg-12'>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                    <h1 style={{ margin: 0 }}>ILDA DASH Registrations</h1>

                                    <div style={{ display: 'flex' }}>
                                        {this.state.fetching && (
                                            <>
                                                <div style={{ marginRight: 5 }}>Fetching registrations...</div>
                                                <Loader size={20} color={'#a1a1a1'} />
                                            </>
                                        )}
                                    </div>
                                    <div style={{ fontSize: 18 }}>
                                        <OverlayTrigger trigger='click' placement='left' rootClose overlay={informationOverlay}><Glyphicon glyph='info-sign' /></OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ marginBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <NavWrapper bsStyle='tabs' verticalAlign='center' minTabWidth={105} activeHref={this.props.match.path} onSelect={(eventKey: any) => this.handleTabChange(eventKey)}>
                                {!isRestrictedToAssigned && (
                                    <NavItem href='/ilda/unassigned'>UNASSIGNED&nbsp;<Badge>{counts.unassigned}</Badge></NavItem>
                                )}
                                <NavItem href='/ilda/to-do'>TO DO&nbsp;<Badge>{counts.todo}</Badge></NavItem>
                                <NavItem href='/ilda/assigned-to-me'>ASSIGNED TO ME&nbsp;<Badge>{counts.assignedToMe}</Badge></NavItem>
                                <NavItem href='/ilda/all'>ALL&nbsp;<Badge>{counts.all}</Badge></NavItem>
                            </NavWrapper>

                            {this.state.currentTab == donorConnectTabs.ALL && (
                                <Filters
                                    userFilter={this.state.userFilter}
                                    statusFilter={this.state.statusFilter}
                                    showFilter={this.state.showFilter}
                                    micrositeRecipient={0}
                                    searchFilter={this.state.searchFilter}
                                    userList={userList}
                                    statusList={this.state.statusList}
                                    micrositeRecipientList={[]}
                                    isRestrictedToAssigned={isRestrictedToAssigned}
                                    onChange={this.handleFilterChange}
                                    onSubmit={this.handleSubmitFilters}
                                />
                            )}
                        </div>

                        <div className='row'>
                            <Wrapper className='col-xs-12 col-lg-12'>
                                <IldaGrid
                                    data={list}
                                    statusList={this.state.statusList}
                                    userList={this.state.userList}
                                    // onGridReady={this.onGridReady}
                                    // onFirstDataRendered={this.onFirstDataRendered}
                                    onView={this.handleViewRegistration}
                                    onStatusChange={this.handleStatusChange}
                                    onAssignedCounselorChange={this.handleAssignedCounselorChange} />
                            </Wrapper>
                        </div>
                    </div>

                    <Drawer
                        width="35vw"
                        // handler={false}
                        placement="right"
                        getContainer={this.getContainer}
                        open={this.state.view.show}
                    >
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <div style={{ padding: 10 }}>
                                <ViewRegistration
                                    data={this.state.view.data}
                                    statusList={this.state.statusList}
                                    actionList={this.state.actionList}
                                    userList={this.state.userList}
                                    clearFile={null}
                                    onStatusChange={this.handleStatusChange}
                                    onCounselorChange={this.handleAssignedCounselorChange}
                                    onNextFollowUpDateChange={this.handleNextFollowUpDateChange}
                                    onUpdateNextFollowUpDate={this.handleUpdateNextFollowUpDate}
                                    onRemoveNextFollowUpDate={this.handleRemoveNextFollowUpDate}
                                    onSaveLogEntry={this.handleSaveLogEntry}
                                    onDeleteLogEntry={this.handleDeleteLogEntry}
                                    onCloseDrawer={this.handleCancelView}
                                />
                            </div>
                        </div>
                    </Drawer>
                </MediaQuery>

                <MediaQuery maxWidth={1023}>
                    <MobileView
                        list={list}
                        currentTab={this.state.currentTab}
                        counts={counts}
                        statusList={this.state.statusList}
                        userList={this.state.userList}
                        actionList={this.state.actionList}
                        onTabChange={this.handleTabChange}
                        onStatusChange={this.handleStatusChange}
                        onAssignedCounselorChange={this.handleAssignedCounselorChange}
                        onNextFollowUpDateChange={this.handleNextFollowUpDateChangeMobile}
                        onUpdateNextFollowupDate={this.handleUpdateNextFollowupDateMobile}
                        onRemoveNextFollowUpDate={this.handleRemoveNextFollowUpDate}
                        onSaveLogEntry={this.handleSaveLogEntry}
                        onDeleteLogEntry={this.handleDeleteLogEntry}
                        onGetIldaLogEntries={this.getLogData}
                    />
                </MediaQuery>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getIldaList: (listType, counselorFilter, statusFilter, showFilter, searchFilter) => {
            return dispatch(DashActionCreators.getIldaList(listType, counselorFilter, statusFilter, showFilter, searchFilter));
        },
        getIldaCounts: () => {
            return dispatch(DashActionCreators.getIldaCounts());
        },
        getLookupData: () => {
            return dispatch(DashActionCreators.getIldaLookupData());
        },
        getIldaLogEntries: (id) => {
            return dispatch(DashActionCreators.getIldaLogEntries(id));
        },
        getIldaRegistration: (id) => {
            return dispatch(DashActionCreators.getIldaRegistration(id));
        },
        changeStatus: (id, status) => {
            return dispatch(DashActionCreators.changeIldaStatus(id, status));
        },
        changeAssignedCounselor: (id, userId) => {
            return dispatch(DashActionCreators.changedIldaAssignedCounselor(id, userId));
        },
        unassignCounselor: (id) => {
            return dispatch(DashActionCreators.unassignIldaCounselor(id));
        },
        updateNextFollowUpDate: (id, date) => {
            return dispatch(DashActionCreators.updateIldaNextFollowUpDate(id, date));
        },
        saveLogEntry: (id, dashRegistrationId, actionTaken, comments) => {
            return dispatch(DashActionCreators.saveIldaLogEntry(id, dashRegistrationId, actionTaken, comments));
        },
        deleteLogEntry: (id) => {
            return dispatch(DashActionCreators.deleteIldaLogEntry(id));
        }

    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(IldaApp);